<af-full-table class="w-100 h-100"
               [showImport]="false"
               [showExport]="false"
               [dataSource]="dataSource"
               (tableUpdateListener)="loadContactDetails($event)"
               [columnTranslationPrefixes]="{status: 'contactDetails'}"
               [filterEvent]="tableEvent.filter"
               [pageEvent]="tableEvent.page"
               [sortEvent]="tableEvent.sortBy"
               [filterFields]="filterFields"
               [hasFilterContent]="true"
               [totalElements]="totalElementsForFilter"
               additionalSpinnerIds="contactDetails"
               placeholderContext="contactDetails"
               emptyStateIconName="ic_empty_state_no_contacts"
               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleContactsNotAdded"
               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleContactsNotAdded"
               [emptyStateButtonLabel]="!incident.isDeleted && !incident.isInnocentStatus ? 'i18n_af_buttonCreateNewContact' : null"
               (emptyStateClickListener)="navigateToCreateContact()">
    <div FilterContent fxLayout="row" fxLayoutAlign="center center" class="pl-16" fxLayoutGap="16px">
        @if (!incident.isDeleted && !incident.isInnocentStatus) {
            <ui-kit-button [label]="'i18n_af_buttonCreateNewContact' | translate"
                           [removePadding]="true"
                           type="text"
                           iconPosition="left"
                           size="small"
                           buttonType="button"
                           icon="ic_plus_ellipse"
                           (clickListener)="navigateToCreateContact()"/>
        }
    </div>
</af-full-table>
